/** Badge de entrega Fastchip vs e-SIM (cores e textos padronizados). */
export type FastchipDeliveryBadgeKind = 'physical' | 'esim' | 'tim';

export interface FastchipDeliveryBadgeMeta {
  kind: FastchipDeliveryBadgeKind;
  label: string;
  /** Cor Semantic UI do Label */
  color: 'orange' | 'purple' | 'grey';
  icon: 'bolt' | 'qrcode' | 'truck';
  popupContent: string;
}

export function contractHasEsimLines(
  lines?: ReadonlyArray<{ isEsim?: boolean | null }> | null
): boolean {
  return lines?.some((line) => line.isEsim === true) ?? false;
}

export function resolveFastchipDeliveryBadge(options: {
  fastchip?: boolean;
  hasEsim?: boolean;
}): FastchipDeliveryBadgeMeta {
  if (!options.fastchip) {
    return {
      kind: 'tim',
      label: 'ENTREGA TIM',
      color: 'grey',
      icon: 'truck',
      popupContent: 'Entrega da operadora (endereço do CNPJ na Receita Federal).',
    };
  }

  if (options.hasEsim) {
    return {
      kind: 'esim',
      label: 'FASTCHIP/E-SIM',
      color: 'purple',
      icon: 'qrcode',
      popupContent: 'Contrato Fastchip com chip virtual (e-SIM) — ativação via QR Code.',
    };
  }

  return {
    kind: 'physical',
    label: 'FASTCHIP',
    color: 'orange',
    icon: 'bolt',
    popupContent: 'Contrato Fastchip com chip físico — aguardando envio do chip.',
  };
}

/** Texto longo para seções do modal (ex.: card de endereço). */
export function resolveFastchipDeliveryDetailLabel(options: {
  fastchip?: boolean;
  hasEsim?: boolean;
}): string {
  const badge = resolveFastchipDeliveryBadge(options);
  if (badge.kind === 'tim') return 'ENTREGA TIM (Receita Federal)';
  if (badge.kind === 'esim') return 'FASTCHIP/E-SIM (chip virtual)';
  return 'FASTCHIP (entrega Gettel)';
}
